// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/webpack-config-single-spa/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/webpack-config-single-spa/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Print styles only.
 *
 * Everything else in this file was Bootstrap-era helpers (sidebar colours,
 * fs-12/fs-11, auth-card, .w-80 and friends) with no remaining callers. One of
 * them was actively dangerous: \`.w-80 { width: 80px !important }\` shadowed
 * Tailwind's own \`w-80\` utility (20rem).
 */

@media print {
  @page {
    size: A4;
    margin: 10mm;
  }

  body * {
    visibility: hidden;
  }

  #printable-order-details,
  #printable-order-details * {
    visibility: visible;
  }

  #printable-order-details {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .no-print {
    display: none !important;
  }

  /* Expand the notes editor (FieldRenderer's .textarea-lines) so long content
     is not clipped on paper. */
  .textarea-lines {
    max-height: none !important;
    overflow: visible !important;
  }

  /* The form is rendered read-only for printing, but the controls still carry
     their on-screen chrome — rounded borders, fills, rings. On paper that
     reads as a screenshot of a form rather than a document, so flatten every
     control to plain underlined text. */
  #printable-order-details input,
  #printable-order-details select,
  #printable-order-details textarea {
    border: none !important;
    border-bottom: 1px solid #ccc !important;
    border-radius: 0 !important;
    background: transparent !important;
    color: #000 !important;
    box-shadow: none !important;
    outline: none !important;
    padding-left: 0 !important;
    -webkit-appearance: none;
    appearance: none;
  }

  /* Panels are surfaces, not paper. Drop their borders and radii so sections
     read as continuous document content. */
  #printable-order-details .panel,
  #printable-order-details section {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  /* Anything interactive is meaningless once printed. */
  #printable-order-details button {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;+BAC6B;EAC7B;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;;wCAGsC;EACtC;;;IAGE,uBAAuB;IACvB,wCAAwC;IACxC,2BAA2B;IAC3B,kCAAkC;IAClC,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,0BAA0B;IAC1B,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;2CACyC;EACzC;;IAEE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA,sDAAsD;EACtD;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/*\r\n * Print styles only.\r\n *\r\n * Everything else in this file was Bootstrap-era helpers (sidebar colours,\r\n * fs-12/fs-11, auth-card, .w-80 and friends) with no remaining callers. One of\r\n * them was actively dangerous: `.w-80 { width: 80px !important }` shadowed\r\n * Tailwind's own `w-80` utility (20rem).\r\n */\r\n\r\n@media print {\r\n  @page {\r\n    size: A4;\r\n    margin: 10mm;\r\n  }\r\n\r\n  body * {\r\n    visibility: hidden;\r\n  }\r\n\r\n  #printable-order-details,\r\n  #printable-order-details * {\r\n    visibility: visible;\r\n  }\r\n\r\n  #printable-order-details {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n\r\n  /* Expand the notes editor (FieldRenderer's .textarea-lines) so long content\r\n     is not clipped on paper. */\r\n  .textarea-lines {\r\n    max-height: none !important;\r\n    overflow: visible !important;\r\n  }\r\n\r\n  /* The form is rendered read-only for printing, but the controls still carry\r\n     their on-screen chrome — rounded borders, fills, rings. On paper that\r\n     reads as a screenshot of a form rather than a document, so flatten every\r\n     control to plain underlined text. */\r\n  #printable-order-details input,\r\n  #printable-order-details select,\r\n  #printable-order-details textarea {\r\n    border: none !important;\r\n    border-bottom: 1px solid #ccc !important;\r\n    border-radius: 0 !important;\r\n    background: transparent !important;\r\n    color: #000 !important;\r\n    box-shadow: none !important;\r\n    outline: none !important;\r\n    padding-left: 0 !important;\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n  }\r\n\r\n  /* Panels are surfaces, not paper. Drop their borders and radii so sections\r\n     read as continuous document content. */\r\n  #printable-order-details .panel,\r\n  #printable-order-details section {\r\n    border: none !important;\r\n    border-radius: 0 !important;\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  /* Anything interactive is meaningless once printed. */\r\n  #printable-order-details button {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
